import axios from 'axios';
import { Params, AxiosParams } from './types';
import { HTTP_HOST, TOKEN } from 'shared/consts';

export const queryBuilder = (path: string, params: Params): string => {
	const paramsMap = Object.entries(params);
	let url: string = HTTP_HOST + path;

	if (paramsMap.length) {
		const searchParams = new URLSearchParams();

		paramsMap.forEach(([key, value]) => {
			if (Array.isArray(value)) {
				value.forEach(item => {
					searchParams.append(key, item.toString());
				});
			} else {
				searchParams.set(key, value?.toString());
			}
		});

		url += `?${searchParams.toString()}`;
	}

	return url;
};

const abortControllers: Record<string, AbortController> = {};

export const axiosRequest = async ({
	path = '',
	params = {},
	headers = {},
	method = 'get',
	abortWithParams = false,
}: AxiosParams) => {
	if (method) {
		const queryUrl = queryBuilder(path, params);
		const url = method === 'get' ? queryUrl : HTTP_HOST + path;

		const axiosMethod = axios[method];

		let requestKey = `${method}-`;

		if (abortWithParams) {
			requestKey += queryUrl;
		} else {
			requestKey += HTTP_HOST + path;
		}

		if (abortControllers[requestKey]) {
			abortControllers[requestKey].abort();
		}

		const controller = new AbortController();
		abortControllers[requestKey] = controller;

		const queryHeaders = {
			...headers,
			Authorization: `ApiKey ${TOKEN}`,
		};

		try {
			const response = await axiosMethod(
				url,
				method === 'get'
					? { headers: queryHeaders, signal: controller.signal }
					: params,
				method === 'get'
					? undefined
					: { headers: queryHeaders, signal: controller.signal },
			);

			if (!response || !response.data) {
				throw new Error('error');
			}

			delete abortControllers[requestKey];
			return response.data;
		} catch (error: any) {
			if (axios.isAxiosError(error) && error.code === 'ERR_CANCELED') {
				console.log('Request aborted:', error.message);
			} else {
				const status = error.request?.status;
				const message = error.message;
				const code = error.code;
				return { status, message, code };
			}

			delete abortControllers[requestKey];
		}
	}
};
